
import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: {
        Loader
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: null,
        },
        isError: {
            type: Boolean,
            default: false,
        }
    },
})
